<template>
  <div class="oa-app" v-if="loaded">
    <a-locale-provider :locale="locale">
      <div class="oaLayout">
        <a-layout id="components-layout-demo-custom-trigger">
          <a-layout-sider :trigger="null" collapsible width="192" v-model="collapsed" :collapsedWidth="48" class="oa-layout-sider" id="oa-layout-sider">
            <div class="logo">
              <img src="./assets/logo.png" :class="{collapsed: collapsed}"> {{collapsed ? '' : '零氪OA系统'}}
            </div>
            <dd-menu :menusData="menusData" v-if="menusData" class="oa-layout-sider--menu"></dd-menu>
          </a-layout-sider>
          <a-layout class="layout-main">
            <a-layout-header style="background: #fff; padding: 0" class="oa-layout-header" id="oa-layout-header">
              <div>
                <a-icon type="mail" class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggleCollapsed" />
                <a-breadcrumb class="breadcrumb">
                  <a-breadcrumb-item v-for="breadcrumb in breadcrumbs">
                    <router-link v-if="breadcrumb.path && breadcrumb.path.name" :to="breadcrumb.path">{{breadcrumb.label}}</router-link>
                    <span v-else>{{breadcrumb.label}}</span>
                  </a-breadcrumb-item>
                </a-breadcrumb>
              </div>
              <span class="flex"></span>
              <div class="user-info">
                <a-dropdown placement="bottomRight">
                  <a>
                    <span class="user-info-img">
                      <a-icon :component="'SvgIcUser'" class="SvgIcUser" />
                      <span class="username">{{userName}}</span>
                    </span>
                  </a>
                  <a-menu slot="overlay" @click="handleLogMenu">
                    <a-menu-item key="logout" style="min-width: 120px;font-size:12px;">
                      退出
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </div>
            </a-layout-header>
            <div class="oa-layout-content" id="oa-layout-content">
              <router-view/>
            </div>
            <a-layout-footer class="oa-layout-footer" id="oa-layout-footer" style="text-align:center">Copyright @2015-2019 零氪科技</a-layout-footer>
          </a-layout>
        </a-layout>
      </div>
    </a-locale-provider>
  </div>
  <div v-else class="loading-spin">
    <a-spin></a-spin>
  </div>
</template>

<script>
import * as dd from 'dingtalk-jsapi';
import moment from 'moment';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { navMenus } from './router';
import ddMenu from './components/DdMenu';
import SvgIcUser from '@/assets/svg/ic-user-2.svg';
import SvgIcNotifications from '@/assets/svg/ic-notifications-2.svg';
import { walkTree } from './utils/tools';
import {
  getCurrentUser,
  getPermission,
  getCurrentPage,
  logout,
  checkLogin,
} from './services/user.js';

import { getLoginUrl } from './services/CommonService.js';

import Vue from 'vue';
import { methods } from './lkadmin/lkadmin';

export default {
  components: {
    ddMenu,
    SvgIcUser,
    SvgIcNotifications,
  },

  data() {
    return {
      locale: zhCN,
      current: ['mail'],
      openKeys: ['sub1'],
      routeName: '',
      collapsed: false,
      forceUpdate: 0, // XXX: 为了让 依赖系统工作, currentViewConfig 及时更新 当 instances 更新的时候
      navMenus,
      menuParentKey: '$$parent',
      menuItemMapKey: '$$menuItemMap',
      loaded: false,
      userName: '',
    };
  },

  computed: {
    breadcrumbs() {
      let m = this.$route.matched.slice(-1)[0];
      let mvc;
      let type;

      this.forceUpdate = Number(this.forceUpdate);
      if (m) {
        // view 实例
        if (!mvc && m.instances.default && m.instances.default.breadcrumb) {
          mvc = m.instances.default.breadcrumb;
          type = 'ins';
        }
        // view 定义
        if (!mvc && m.components.default && m.components.default.breadcrumb) {
          mvc = m.components.default.breadcrumb;
          type = 'com';
        }
      }
      if (!mvc) {
        mvc = [];
        type = 'none';
      }
      return mvc;
    },

    menus() {
      const menus = this.navMenus;
      if (menus) {
        const map = {};

        walkTree(
          menus,
          (node, {}, pNode) => {
            if (pNode) {
              Object.defineProperty(node, this.menuParentKey, {
                enumerable: false,
                configurable: true,
                value: pNode,
              });
            }

            const isMenuItem = !node.children && !node.groupTitle;
            if (isMenuItem) {
              map[node.key] = node;
            }
          },
          { rootAsChildren: true, childrenKey: 'children' },
        );

        Object.defineProperty(menus, this.menuItemMapKey, {
          enumerable: false,
          configurable: true,
          value: map,
        });
      }
      return menus;
    },

    menusData() {
      const { $route, menus } = this;
      let defaultSelectedKeys = [];
      let openKeys = [];

      if (!$route.name || $route.name === 'login') {
        return null;
      }

      let { name, meta: { matchNav } } = $route;
      if (matchNav) {
        defaultSelectedKeys.push(matchNav);
        name = matchNav;
      } else {
        defaultSelectedKeys.push(name);
      }

      const menuItem = name ? menus[this.menuItemMapKey][name] : null;
      if (menuItem) {
        let p = menuItem;
        while ((p = p[this.menuParentKey])) {
          if (!p.groupTitle && p.key) {
            openKeys.push(p.key);
          }
        }
      }
      return {
        menus,
        openKeys,
        defaultSelectedKeys,
      };
    },

    currentViewConfig() {
      let m = this.$route.matched.slice(-1)[0];
      let mvc;
      let type;

      this.forceUpdate = Number(this.forceUpdate);

      if (m) {
        if (!mvc && m.instances.default && m.instances.default.lkAdmin) {
          mvc = m.instances.default.lkAdmin;
          type = 'ins';
        }
        if (!mvc && m.components.default && m.components.default.lkAdmin) {
          mvc = m.components.default.lkAdmin;
          type = 'com';
        }
      }
      if (!mvc) {
        mvc = {};
        type = 'none';
      }

      return mvc;
    },

    currentNav() {
      return this.currentViewConfig.nav || null;
    },
  },

  methods: {
    ...methods,

    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },

    // setCookie(c_name, value, expire) {
    //   var date = new Date();
    //   date.setSeconds(date.getSeconds() + expire);
    //   document.cookie =
    //     c_name + '=' + escape(value) + '; expires=' + date.toGMTString();
    //   //console.log(document.cookie)
    // },

    mvcMayChange() {
      // called when router-view rendered
      // 不能放到 $route change 里做的原因是, container 初始化后的 lkAdmin 配置无法被更新
      this.forceUpdate += 1;
    },

    goToLogin() {
      getLoginUrl().then(res => {
        if (res.status === 'success') {
          location.href = res.data[0];
        }
      });
    },

    checkRoute(route) {
      if (!route || !route.meta) {
        return true;
      }

      const { checkFn, checkAction, checkRole } = route.meta;

      return this.checkPerm(
        { checkFn, checkAction, checkRole },
        { ctx: route, src: 'route' },
      );
    },

    initAdmin() {
      this.$router.beforeEach((to, from, next) => {
        if (!this.checkRoute(to)) {
          next('/403');
        } else {
          next();
        }
      });
    },

    initPage() {
      this.loaded = false;
      Promise.all([getCurrentUser()])
        .then(([{ status, data }]) => {
          if (status !== 'success') {
            this.loaded = true;
            this.goToLogin();
          } else {
            // localStorage.setItem('accessToken', data.accessToken);
            // this.setToken();
            this.setPermissions();
          }
        })
        .catch(err => {});
    },

    setPermissions() {
      getPermission().then(permissions => {
        this.userName = permissions.userName;
        this.loaded = true;
        this.initAdmin();
        this.$lkAdmin.user = {
          ...this.$lkAdmin.user,
          permissions,
        };
      });
    },

    handleLogMenu({ key }) {
      switch (key) {
        case 'my-settings':
          return;
        case 'logout':
          this.doLogout();
          return;
      }
    },

    doLogout() {
      logout().then(res => {
        if (res.status === 'success') {
          this.goToLogin();
        } else {
          this.$Message.error(res.message.description);
        }
      });
    },

    getCookie(name) {
      var arr,
        reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');

      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },

    GetQueryString(name) {
      var reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i');
      var r = window.location.hash.substr(1).match(reg); //search,查询？后面的参数，并匹配正则

      if (r != null) return unescape(r[2]);
      return null;
    },
  },

  created() {
    // 在dom渲染前注册_lkAdmin属性到全局，确保this.$lkAdmin 调用,同时给this.$lkAdmin赋值methods上各个方法
    this.$options._base.util.defineReactive(this.$root, '_lkAdmin', this);
    if (
      /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ||
      /(Android)/i.test(navigator.userAgent)
    ) {
      this.isMobile = true;
    } else {
      //pc
      this.isMobile = false;
    }

    if (this.isMobile) {
      const code = this.GetQueryString('code');
      location.href = `${window.location.origin}/app.html#/home?code=${code}`;
      return;
    }

    if (dd.ready()) {
      const code = this.GetQueryString('code');
      location.href = `${
        window.location.origin
      }/ddIndex.html#/launchApplication?code=${code}`;
    }
  },

  mounted() {
    checkLogin().then(res => {
      if (res.status === 'success') {
        if (res.data[0]) {
          this.setPermissions();
        } else {
          if (this.GetQueryString('code')) {
            this.initPage();
          } else {
            this.goToLogin();
          }
        }
      }
    });
    // if (
    //   this.GetQueryString('code') &&
    //   this.GetQueryString('code') !== localStorage.getItem('code')
    // ) {
    //   localStorage.setItem('code', this.GetQueryString('code'));
    //   this.initPage();
    // } else {
    //   checkLogin().then(res => {
    //     if (res.status === 'success') {
    //       this.setPermissions();
    //     }
    //   });
    // }
  },
};
</script>

<style lang="less">
@import url('./common.less');

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.oa-app {
  min-width: 1280px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  .ant-layout.ant-layout-has-sider > .ant-layout,
  .ant-layout.ant-layout-has-sider > .ant-layout-content {
    overflow-x: inherit;
    width: calc(100% - 192px);
  }
  .oaLayout {
    > .ant-layout {
      min-height: 100vh;
    }
    .ant-menu-inline-collapsed > .ant-menu-item {
      padding: 0 16px !important;
    }
    .oa-layout-sider {
      position: relative;
      z-index: 11;
      display: flex;
      .ant-layout-sider-children {
        flex: auto;
        display: flex;
        flex-direction: column;
        height: 100%;
        .oa-layout-sider--menu {
          /*flex: auto;*/
          height: 100%;
        }
      }
    }
    .layout-main {
      flex: auto;
      .oa-layout-content {
        flex: auto;
      }
    }
    .logo {
      margin-top: 32px;
      margin-bottom: 53px;
      color: #b2b9bf;
      font-weight: 600;
      font-size: 16px;
      line-height: 40px;
      text-align: center;
      img {
        transition: all 0.2s;
        display: block;
        margin: 0 auto;
        height: 35px;
        width: 125px;
        visibility: visible;
        opacity: 1;
        &.collapsed {
          opacity: 0;
          visibility: hidden;
          width: 0;
        }
      }
    }
    .ant-menu {
      .ant-menu-item {
        text-align: left;
      }
      .ant-menu-submenu-title {
        padding: 0 20px;
        text-align: left;
      }
    }
    & .oa-layout-header {
      position: relative;
      height: 44px;
      display: flex;
      align-items: center;
      flex: 0 0 auto;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
      // margin-bottom: 5px;
      z-index: 9;
      & .trigger {
        font-size: 12px;
        line-height: 44px;
        padding: 0 12px;
        cursor: pointer;
        transition: color 0.3s;
        &:hover {
          color: #1890ff;
        }
      }
      & .breadcrumb {
        display: inline-block;
        font-size: 12px;
      }
      .flex {
        flex: auto;
      }
      .user-info {
        display: inline-block;
        font-size: 12px;
        .SvgIcNotifications {
          font-size: 16px;
        }
        &-img {
          display: block;
          height: 30px;
          line-height: 30px;
          margin: 0 24px 0 20px;
          border-radius: 50%;
          min-width: 100px;
          .SvgIcUser {
            font-size: 20px;
            margin-left: 4px;
            margin-right: 8px;
            color: #ff0000;
            vertical-align: top;
            margin-top: 5px;
            path {
              color: #fff;
              opacity: 0.7;
            }
            path:first-child {
              color: #000;
              opacity: 0.15;
            }
          }
          .username {
            color: #595959;
          }
        }
      }
    }
    .isNoChildMenu {
      .ant-menu {
        display: none;
      }
    }
    .isNoChildMenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {
      display: none;
    }
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
  .ant-input.ant-input-disabled {
    background: #eee;
    color: rgba(0, 0, 0, 0.24);
    cursor: not-allowed;
  }
  td {
    vertical-align: top;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    box-sizing: padding-box;
    padding: 8px 8px;
    line-height: 24px;
    font-size: 12px;
    word-break: break-all;
    white-space: pre-wrap;
  }
  .ant-table-tbody > tr > td .anticon-up svg,
  .ant-table-tbody > tr > td .anticon-down svg {
    -webkit-transform: scale(0.5);
    transform: scale(0.8);
  }
  .ant-table-tbody > tr td {
    min-height: 100%;
  }
  span.ant-table-row-expand-icon {
    margin-top: 3px;
  }
  p {
    margin-bottom: 0;
  }
  .ant-card-wider-padding .ant-card-body {
    padding: 24px 16px;
  }
}
</style>
